<template>
    <div class="mb-3">
        <b-navbar toggleable="sm" type="dark" variant="primary">

            <a class="navbar-brand" href="#"></a>
            <div id="logo">
                <b-link class="navbar-brand" to="/">
                    <img class="mt-3" :src="'../img/logo.png'" alt="">
                </b-link>
            </div>

            <b-navbar-toggle target="sidebar-1"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">

                    <b-form-select v-model="lang" :plain="true" :options="langOpt" class="mt-1 bg-primary text-light"></b-form-select>

                    <b-nav-item-dropdown right v-if="isAuthenticated" class="mt-1">
                        <!-- Using 'button-content' slot -->
                        <template v-slot:button-content>
                            <em v-if="name">{{$t('Hi')}}, {{name}}</em>
                            <em v-if="!name">{{$t('Hi')}}, Guest</em>
                        </template>
                        <b-dropdown-item @click="logout"><b-icon class="mr-1" icon="box-arrow-down-right" font-scale="1" />{{$t('SignOut')}}</b-dropdown-item>
                    </b-nav-item-dropdown>

                </b-navbar-nav>
            </b-collapse>

            <!--SIDE BAR-->
            <b-sidebar id="sidebar-1" shadow bg-variant="primary">
                <template v-if="isAuthenticated" slot="title">
                    {{$t('Hi') + ', ' + name}}
                </template>
                <template v-slot:default="{ hide }">
                    <b-col v-if="isAuthenticated">
                        <b-col variant="primary" class="mt-4">
                            <h5>
                                <b-icon-book font-scale="1" />
                                <b-link to="/" @click="hide" class="text-dark">
                                    {{$t('OrderList')}}
                                </b-link>
                            </h5>
                        </b-col>
                        <b-col variant="primary" class="mt-4">
                            <h5>
                                <b-icon-file-plus font-scale="1" />
                                <b-link to="/ilt" @click="hide" class="text-dark">
                                    {{$t('ILTList')}}
                                </b-link>
                            </h5>
                        </b-col>
                    </b-col>
                </template>

                <template v-slot:footer="{ hide }">
                    <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
                        <strong class="mr-auto">{{$t('Language')}} : </strong>
                        <b-col class="col mb-1">
                            <b-form-select v-model="lang" :options="langOpt" class="mt-2 bg-secondary text-light" />
                        </b-col>
                        <b-button class="mt-1" @click="logout" v-if="isAuthenticated">{{$t('SignOut')}}</b-button>
                    </div>

                    <div class="footer-copyright text-center bg-dark text-white py-3">
                        2020 -
                        <a href="https://reinder.eu/"> REINDER.EU</a>
                    </div>
                </template>
            </b-sidebar>

        </b-navbar>

        <!--MAIN MENU-->
        <b-col class="d-none d-sm-block mt-5 pt-5 px-5 " v-if="isAuthenticated">
            <b-navbar type="dark" class="py-0" variant="info">
                <b-navbar-nav class="mr-auto">
                    <b-nav-item class=" custom-nav-link navbar-brand my-0" to="/">{{$t('OrderList')}}</b-nav-item>
                    <b-nav-item class=" custom-nav-link navbar-brand my-0" to="/ilt2">{{$t('ILTList')}}</b-nav-item>
                </b-navbar-nav>
            </b-navbar>
        </b-col>
    </div>
</template>

<script>
    import { mapGetters, mapState } from "vuex";
    import { AUTH_LOGOUT } from "actions/auth";

    export default {
        name: "Navigation",
        data() {
            return {
                lang: localStorage.getItem("lang") || 'nl',
                langOpt: [
                    { value: 'en', text: 'EN' },
                    { value: 'nl', text: 'NL' }
                ]
            }
        },
        watch: {
            lang: function (value) {
                this.$i18n.locale = value;
                document.querySelector('html').setAttribute('lang', value);
                localStorage.setItem("lang", value);
            }
        },
        methods: {
            logout: function () {
                this.$store.dispatch(AUTH_LOGOUT);
            },
            setI18nLanguage(lang) {
                this.$i18n.locale = lang;
                document.querySelector('html').setAttribute('lang', lang);
                localStorage.setItem("lang", lang);
                this.language = lang;
            }
        },

        computed: {
            ...mapGetters(["isAuthenticated"]),
            ...mapState({
                authLoading: state => state.auth.status === "loading",
                language: state => state.driver.lang,
                name: state => `${state.driver.driverInfo.UserName}`
            })
        }
    };
</script>

<style>
    #logo {
        position: absolute;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        height: 123px;
        width: 123px;
        margin-top: 30px;
    }

        #logo a {
            height: 123px;
            width: 123px;
            display: block;
        }

    .facebook, .linkedin, .twitter {
        fill: white;
    }
</style>